"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientAsyncInit = void 0;
const react_1 = require("react");
const client_core_1 = require("@statsig/client-core");
const requireOptionalDependency_1 = require("./requireOptionalDependency");
function useClientAsyncInit(sdkKey, initialUser, statsigOptions = null) {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [args] = (0, react_1.useState)(() => {
        const client = (0, requireOptionalDependency_1.requireOptionalClientDependency)(sdkKey, initialUser, statsigOptions);
        client
            .initializeAsync()
            .catch(client_core_1.Log.error)
            .finally(() => setIsLoading(false));
        return { client, initialUser, sdkKey };
    });
    return { client: args.client, isLoading };
}
exports.useClientAsyncInit = useClientAsyncInit;
